import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { type ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { type TokenClaims } from "../../core/auth/auth";

interface NavItem {
  to: string;
  label: string;
  icon: ReactNode;
  roles?: string[];
  end?: boolean;
}

const NAV_ITEMS: NavItem[] = [
  { to: "/", label: "Inicio", icon: <HomeOutlinedIcon fontSize="small" />, end: true },
  {
    to: "/users",
    label: "Usuarios",
    icon: <PeopleOutlineIcon fontSize="small" />,
    roles: ["admin", "user_manager"],
  },
  { to: "/profile", label: "Mi perfil", icon: <PersonOutlineIcon fontSize="small" /> },
];

interface SidebarProps {
  claims: TokenClaims;
}

const Sidebar = ({ claims }: SidebarProps) => {
  const visibleItems = NAV_ITEMS.filter(
    (item) => !item.roles || item.roles.some((r) => claims.roles.includes(r)),
  );

  return (
    <Box
      component="nav"
      sx={{
        width: 240,
        flexShrink: 0,
        bgcolor: "var(--color-surface)",
        borderRight: "1px solid var(--color-border)",
        overflowY: "auto",
        pt: 2,
      }}
    >
      <List disablePadding>
        {visibleItems.map((item) => (
          <NavLink key={item.to} to={item.to} end={item.end} style={{ textDecoration: "none" }}>
            {({ isActive }) => (
              <ListItemButton
                sx={{
                  mx: 1,
                  mb: 0.5,
                  borderRadius: 1,
                  alignItems: "center",
                  borderLeft: isActive ? "3px solid var(--color-accent)" : "3px solid transparent",
                  bgcolor: isActive ? "var(--color-accent-bg, rgba(15,118,110,0.08))" : "transparent",
                  color: isActive ? "var(--color-accent)" : "var(--color-text-secondary)",
                  "&:hover": {
                    bgcolor: isActive
                      ? "var(--color-accent-bg, rgba(15,118,110,0.08))"
                      : "var(--color-surface-raised)",
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 32,
                    display: "flex",
                    alignItems: "center",
                    color: isActive ? "var(--color-accent)" : "var(--color-text-secondary)",
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.label}
                  slotProps={{
                    primary: {
                      fontSize: 15,
                      fontWeight: isActive ? 600 : 400,
                      lineHeight: "normal",
                      display: "flex",
                      alignItems: "center",
                    },
                  }}
                />
              </ListItemButton>
            )}
          </NavLink>
        ))}
      </List>
    </Box>
  );
};

export default Sidebar;
